// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

// import "prismjs/themes/prism.css"
import "./src/styles/main.css"
